// Leitura da fila de abastecimento com "última requisição vence": cada nova leitura aborta a anterior e só a
// resposta da leitura mais recente chega à tela, que SUBSTITUI a lista (nunca acumula). Sem React, para teste direto.
import type { FiltroFilaAbastecimento, ListaFilaAbastecimento } from '@pieltec/contracts';
import { linhaDaFila, type LinhaFila } from './abastecimento-linha';

export interface FilaCarregada {
  readonly itens: readonly LinhaFila[];
  readonly total: number;
}

export interface CarregadorFilaDeps {
  readonly listar: (filtro: FiltroFilaAbastecimento, opcoes: { readonly signal: AbortSignal }) => Promise<ListaFilaAbastecimento>;
  /** Recebe a fila inteira da resposta mais recente; quem chama substitui o estado anterior. */
  readonly aplicar: (fila: FilaCarregada) => void;
  readonly falhar: () => void;
}

export interface CarregadorFila {
  /** Resolve `true` quando esta leitura foi aplicada; `false` quando outra mais recente a substituiu. */
  carregar(filtro: FiltroFilaAbastecimento): Promise<boolean>;
  cancelar(): void;
}

export function criarCarregadorFila({ listar, aplicar, falhar }: CarregadorFilaDeps): CarregadorFila {
  let sequencia = 0;
  let controle: AbortController | null = null;
  return {
    async carregar(filtro) {
      controle?.abort();
      const meu = new AbortController();
      controle = meu;
      const minha = ++sequencia;
      try {
        const resposta = await listar(filtro, { signal: meu.signal });
        if (minha !== sequencia || meu.signal.aborted) return false;
        aplicar({ itens: resposta.itens.map(linhaDaFila), total: resposta.total });
        return true;
      } catch {
        if (minha !== sequencia || meu.signal.aborted) return false;
        falhar();
        return false;
      }
    },
    cancelar() {
      sequencia += 1;
      controle?.abort();
      controle = null;
    },
  };
}
